export default "__VITE_ASSET__DVpS_iQ2__"